import { __rest, __spreadArray, __assign } from '../../_virtual/_tslib.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import * as constants from '../../constants/constants.js';
import useStyles from '../../hooks/useStyles.js';
import useOnClickOutside from '../../hooks/useOnClickOutside.js';
import cn from 'classnames';
import Icon from '../Icon/index.js';
import { OptionWrapper, CheckBoxWrapper, SelectWrapper, StDropdown, SearchWrapper, List, ButtonWrapper, SelectButton, TextWrapper, IconWrapper } from './styles/styles.js';
import Search from '../Search/index.js';
import Checkbox from '../Checkbox/index.js';
import Button from '../Button/index.js';
import Tooltip from '../Tooltip/index.js';
import { DirectionalHint, TooltipDelay } from '@fluentui/react';
import Collapse from '../Collapse/index.js';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';

var Select = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.options, options = _f === void 0 ? [] : _f, _g = _a.buttonText, buttonText = _g === void 0 ? 'Save' : _g, _h = _a.labelText, labelText = _h === void 0 ? 'Metrics' : _h, _j = _a.text, text = _j === void 0 ? 'Selected' : _j, _k = _a.mode, mode = _k === void 0 ? 'multi' : _k, _l = _a.dropdownAlign, dropdownAlign = _l === void 0 ? 'left' : _l, _m = _a.dropdownWidth, dropdownWidth = _m === void 0 ? 'md' : _m, _o = _a.maxSelected, maxSelected = _o === void 0 ? 0 : _o, _p = _a.minSelected, minSelected = _p === void 0 ? 0 : _p, handleSelect = _a.handleSelect, handleCheck = _a.handleCheck, iconType = _a.iconType, _q = _a.disabled, disabled = _q === void 0 ? false : _q, _r = _a.outsideText, outsideText = _r === void 0 ? null : _r, _s = _a.outsideCloseDropdown, outsideCloseDropdown = _s === void 0 ? { close: false } : _s, _t = _a.outsideSelected, outsideSelected = _t === void 0 ? null : _t, _u = _a.showFilter, showFilter = _u === void 0 ? true : _u, additionalControl = _a.additionalControl, _v = _a.fullWidth, fullWidth = _v === void 0 ? false : _v, props = __rest(_a, ["options", "buttonText", "labelText", "text", "mode", "dropdownAlign", "dropdownWidth", "maxSelected", "minSelected", "handleSelect", "handleCheck", "iconType", "disabled", "outsideText", "outsideCloseDropdown", "outsideSelected", "showFilter", "additionalControl", "fullWidth"]);
    var _w = useState(false), showDropdown = _w[0], setShowDropdown = _w[1];
    var _x = useState([]), selectedOptions = _x[0], setSelectedOptions = _x[1];
    var _y = useState([]), tempSelectedOptions = _y[0], setTempSelectedOptions = _y[1];
    var _z = useState(''), filter = _z[0], setFilter = _z[1];
    var wrapperRef = useRef(null);
    var mergedStyles = useStyles({ props: props, constants: constants });
    var t = useTranslation().t;
    useEffect(function () {
        outsideSelected && setSelectedOptions(__spreadArray([], outsideSelected, true));
    }, [outsideSelected]);
    useEffect(function () {
        if (!showDropdown)
            return;
        outsideCloseDropdown.close && setShowDropdown(function () { return false; });
    }, [outsideCloseDropdown]);
    /**
     * Как только открывается дродаун,
     * пишем текущий стейт во временный
     */
    useEffect(function () {
        if (showDropdown) {
            setTempSelectedOptions(selectedOptions);
        }
    }, [showDropdown]);
    useOnClickOutside(wrapperRef, clickOutsidehandler);
    /**
     * Если кликнули вне открытого дродауна, то пишем в локалстейт
     * ранее сохраненный tempSelectedOptions
     * и закрываем дродаун
     */
    function clickOutsidehandler(e) {
        if (showDropdown) {
            setSelectedOptions(tempSelectedOptions);
            setShowDropdown(function () { return false; });
        }
        // handleSelect && handleSelect(selectedOptions);
    }
    var toggleDropdown = function (e) {
        // !showDropdown && e.stopPropagation();
        setShowDropdown(function () { return !showDropdown; });
    };
    var onCheck = function (_a) {
        var option = _a.option, section = _a.section;
        return function (args) {
            var index = selectedOptions.findIndex(function (item) { return item.id === option.id; });
            var clone = cloneDeep(selectedOptions);
            if (index !== -1 && !args.checked) {
                clone.splice(index, 1);
                setSelectedOptions(clone);
            }
            else {
                setSelectedOptions(__spreadArray(__spreadArray([], selectedOptions, true), [__assign(__assign({}, option), { section: section })], false));
            }
            handleCheck && handleCheck(__assign(__assign({}, option), { section: section, checked: args.checked }));
        };
    };
    var onSelectSingle = function (_a) {
        var option = _a.option, section = _a.section;
        return function () {
            !outsideSelected && setSelectedOptions([__assign(__assign({}, option), { section: section })]);
            setShowDropdown(function () { return false; });
            handleSelect && handleSelect([__assign(__assign({}, option), { section: section })]);
        };
    };
    var dropdownClassName = useMemo(function () {
        var _a;
        return cn("dropdown-container paddings dropdown-menu", (_a = {},
            _a["show"] = showDropdown,
            _a));
    }, [showDropdown, dropdownWidth]);
    var filterOnChange = function (_a) {
        var value = _a.value;
        setFilter(function () { return value; });
    };
    var isSimple = function (options) {
        return options.every(function (item) { return item.hasOwnProperty('id') && item.hasOwnProperty('text'); });
    };
    var isNested = function (options) {
        return options.every(function (item) { return item.hasOwnProperty('section') && item.hasOwnProperty('objects'); });
    };
    var handleAdditionalControlClick = function (label) {
        var section = label.split(' ')[0];
        var newSelectedOptions = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter(function (item) { return item.section !== section; });
        newSelectedOptions.length >= minSelected && setSelectedOptions(newSelectedOptions);
    };
    var list = useMemo(function () {
        var _a;
        if (mode === 'single' && isSimple(options)) {
            var simpleOptions = options;
            return simpleOptions === null || simpleOptions === void 0 ? void 0 : simpleOptions.filter(function (option) { return filter === '' || option.text.toLowerCase().includes(filter.toLowerCase()); }).map(function (option) {
                var selected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) { return item.id === option.id; })) !== undefined;
                return (jsx(OptionWrapper, __assign({ onClick: onSelectSingle({ option: option, section: '' }), selected: selected }, { children: option.text }), "".concat(option.text, "==").concat(option.id)));
            });
        }
        else if (isSimple(options)) {
            var simpleOptions = options;
            return simpleOptions === null || simpleOptions === void 0 ? void 0 : simpleOptions.filter(function (option) { return filter === '' || option.text.toLowerCase().includes(filter.toLowerCase()); }).map(function (option) {
                var selected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (item) { return item.id === option.id; })) !== undefined;
                var disabled = minSelected ? selected && selectedOptions.length <= minSelected : false;
                if (maxSelected && selectedOptions.length >= maxSelected && !selected) {
                    disabled = true;
                }
                return (jsx(CheckBoxWrapper, { children: jsx(Checkbox, { label: option.text, handleToggle: onCheck({ option: option, section: '' }), id: option.id, selected: selected, disabled: disabled }, void 0) }, "".concat(option.text, "==").concat(option.id)));
            });
        }
        else if (isNested(options)) {
            var nestedOptions = options;
            var filteredOptions = (_a = nestedOptions
                .map(function (item) {
                var _a;
                var objects = (_a = item.objects) === null || _a === void 0 ? void 0 : _a.filter(function (option) { return filter === '' || option.text.toLowerCase().includes(filter.toLowerCase()); });
                return __assign(__assign({}, item), { objects: objects });
            })) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.objects.length; });
            return filteredOptions.map(function (item) {
                var list = item.objects.map(function (option) {
                    var selected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (obj) { return obj.id === option.id; })) !== undefined;
                    var disabled = minSelected ? selected && selectedOptions.length <= minSelected : false;
                    if (maxSelected && selectedOptions.length >= maxSelected && !selected) {
                        disabled = true;
                    }
                    if (selected) {
                        disabled = false;
                    }
                    return (jsx(CheckBoxWrapper, { children: jsx(Checkbox, { label: option.text, handleToggle: onCheck({ option: option, section: item.section }), id: option.id, selected: selected, disabled: disabled }, void 0) }, "".concat(option.text, "==").concat(option.id)));
                });
                var numberSelectedItemsOfSection = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter(function (obj) {
                    return obj.section === item.section;
                }).length;
                return (jsx(Collapse, __assign({ hover: "background-none", icon: "chevron-right", label: "".concat(item.section, " (").concat(numberSelectedItemsOfSection, "/").concat(item.objects.length, ")"), addClasses: 'SelectCollapse', iconPosition: "right", handleAdditionalControlClick: handleAdditionalControlClick, additionalControl: additionalControl }, { children: list }), "".concat(item.section)));
            });
        }
        else
            return [];
    }, [options, filter, selectedOptions, mode, outsideSelected]);
    var tooltipProps = useMemo(function () {
        return {
            onRenderContent: function () { return (jsx(Fragment, { children: selectedOptions.map(function (obj) {
                    var section = obj.section ? "".concat(obj.section, ": ") : '';
                    return (jsxs(React.Fragment, { children: [jsx("span", { children: "".concat(section).concat(obj.text) }, void 0), jsx("br", {}, void 0)] }, obj.id));
                }) }, void 0)); },
        };
    }, [options, selectedOptions]);
    var onSaveButtonClick = function () {
        handleSelect && handleSelect(selectedOptions);
        setShowDropdown(function () { return false; });
    };
    var singleModeText = text;
    if (mode === 'single' && outsideText !== null) {
        singleModeText = outsideText;
    }
    else if (mode === 'single') {
        if ((_b = Object.keys(selectedOptions)) === null || _b === void 0 ? void 0 : _b.length) {
            singleModeText = (_c = Object.keys(selectedOptions)) === null || _c === void 0 ? void 0 : _c.map(function (key) {
                return selectedOptions[key].text;
            })[0];
        }
    }
    var className = React.useMemo(function () {
        return cn(__spreadArray(['btn btn-bordered-primary text-left btn-selected'], mergedStyles, true));
    }, [mergedStyles]);
    return (jsxs(SelectWrapper, __assign({ disabled: disabled, ref: wrapperRef, fullWidth: fullWidth }, { children: [jsxs(StDropdown, __assign({ className: dropdownClassName, width: dropdownWidth, dropdownAlign: dropdownAlign }, { children: [showFilter && (jsx(SearchWrapper, { children: jsx(Search, { fullWidth: true, placeholder: t('Filter'), handleChange: filterOnChange }, void 0) }, void 0)), jsx(List, __assign({ mode: mode }, { children: list }), void 0), mode === 'multi' && (jsx(ButtonWrapper, { children: jsx(Button, __assign({ size: "sm", margin: "t_xxs", onClick: onSaveButtonClick }, { children: buttonText }), void 0) }, void 0))] }), void 0), jsx("div", __assign({ className: 'filters-form__item-label' }, { children: labelText }), void 0), Object.keys(selectedOptions).length && mode === 'multi' && !showDropdown ? (jsx(Tooltip, __assign({ tooltipProps: tooltipProps, calloutProps: { isBeakVisible: true, beakWidth: 16, gapSpace: 5 }, directionalHint: DirectionalHint.topAutoEdge, delay: TooltipDelay.long }, { children: jsxs(SelectButton, __assign({ fullWidth: fullWidth, className: className, onClick: toggleDropdown, disabled: disabled }, { children: [jsxs(TextWrapper, { children: [jsx("span", { children: text }, void 0), jsx("span", { children: ": ".concat((_d = Object.keys(selectedOptions)) === null || _d === void 0 ? void 0 : _d.length) }, void 0)] }, void 0), iconType && (jsx(IconWrapper, { children: jsx(Icon, { size: "xxs", type: iconType, color: props.color }, void 0) }, void 0))] }), void 0) }), void 0)) : (jsxs(SelectButton, __assign({ fullWidth: fullWidth, className: className, onClick: toggleDropdown, disabled: disabled }, { children: [jsxs(TextWrapper, { children: [jsx("span", { children: singleModeText }, void 0), mode === 'multi' && jsx("span", { children: ": ".concat((_e = Object.keys(selectedOptions)) === null || _e === void 0 ? void 0 : _e.length) }, void 0)] }, void 0), iconType && (jsx(IconWrapper, { children: jsx(Icon, { size: "xxs", type: iconType, color: props.color }, void 0) }, void 0))] }), void 0))] }), void 0));
};

export { Select as default };
